import { r4Client, r4Error } from '@/services'

const MailEventsApi = {
  async fetchMailEvents (dealerId, emails, queryName) {
    try {
      const resp = await r4Client().get('/api/v1/query_engine/mail_events', { params: { dealer_id: dealerId, emails: emails, query_name: queryName } })
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  }
}

export default MailEventsApi
